const MainMenu = [
  {
    title: "Upload new transcript",
    path: "/upload",
  },
];

const FooterMenu = [
  {
    title: "About Transcript app",
    path: "/about",
  },
  {
    title: "Credits",
    path: "/credits",
  },
];

const Menus = {
  MainMenu,
  FooterMenu,
};

export default Menus;
